import { LevelListItemStatus } from '../stories/LevelListItem';
import { LessonIndexPageUnit } from './LessonIndexPageUnit';
import { LevelStatus } from './LevelStatus';

export interface LessonIndexPageLevel {
  id: number;
  position: number;
  title: string;
  current: boolean;
  status: LevelStatus;
  thumbSrc: string;
  eolTestAllowed: boolean;
  units: LessonIndexPageUnit[];
}

export const getLessonIndexPageLevelStatus = (level: LessonIndexPageLevel): LevelListItemStatus => {
  switch (level.status) {
    case 'in_progress':
      return 'current';
    case 'completed':
      return 'done';
    case 'pending':
    default:
      return 'blocked';
  }
};
